import { MutationTree } from "vuex";

import { createStoreModulePath } from "@/lib/store.utils";

import { ErrorsState } from "./types";

export const rootErrorsMutationBuilder = createStoreModulePath('errors');
export const mutationTypes = {
  setError: 'setError',
  setErrors: 'setErrors',
  clear: 'clear',
} as const;

export const mutations: MutationTree<ErrorsState> = {
  [mutationTypes.setError](state, value: string | null = null) {
    state.errors = [value ?? 'general.error'];
  },
  [mutationTypes.setErrors](state, values: string[]) {
    state.errors = values;
  },
  [mutationTypes.clear](state) {
    state.errors = [];
  }
};
